module.exports = __webpack_public_path__ + "img/add_large_icon.16e6b91c.svg";